var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import { Button } from "@riseart/common";
import { ViewInRoomIcon } from "@riseart/icons";
import { Overlay, OverlayHeader, OverlayBody } from "@riseart/layout";
import { ViewInRoomPreview } from "./Preview";
import { viewInRoomButtonCls } from "./ViewInRoom.less";
var ViewInRoomButton = /* @__PURE__ */ function(_Component) {
  function ViewInRoomButton2(props) {
    var _this;
    _classCallCheck(this, ViewInRoomButton2);
    _this = _callSuper(this, ViewInRoomButton2, [props]);
    _this.state = {
      isOpened: false
    };
    _this.bindMethods();
    return _this;
  }
  __name(ViewInRoomButton2, "ViewInRoomButton");
  _inherits(ViewInRoomButton2, _Component);
  return _createClass(ViewInRoomButton2, [{
    key: "handleClick",
    value: /* @__PURE__ */ __name(function handleClick() {
      this.setState(function(state) {
        return {
          isOpened: !state.isOpened
        };
      });
    }, "handleClick")
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleClick = this.handleClick.bind(this);
    }, "bindMethods")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$props = this.props, scaled = _this$props.scaled, previewConfig = _this$props.previewConfig, imageWidth = _this$props.imageWidth, imageHeight = _this$props.imageHeight, previewComponent = _this$props.previewComponent, backgroundPicture = _this$props.backgroundPicture, children = _this$props.children, overlayHeader = _this$props.overlayHeader;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
        icon: /* @__PURE__ */ React.createElement(ViewInRoomIcon, null),
        type: "link",
        linkType: "light",
        className: viewInRoomButtonCls,
        onClick: this.handleClick
      }, children), this.state.isOpened ? /* @__PURE__ */ React.createElement(Overlay, {
        isVisible: true,
        onClose: this.handleClick
      }, /* @__PURE__ */ React.createElement(OverlayHeader, null, typeof overlayHeader === "function" ? overlayHeader() : null), /* @__PURE__ */ React.createElement(OverlayBody, {
        sizes: {
          xs: "fullWidth",
          sm: "fullWidth",
          md: "fullWidth",
          lg: "fullWidth",
          xl: "wide"
        }
      }, /* @__PURE__ */ React.createElement(ViewInRoomPreview, {
        scaled,
        config: previewConfig,
        width: imageWidth,
        height: imageHeight,
        backgroundPicture
      }, previewComponent))) : null);
    }, "render")
  }]);
}(Component);
_defineProperty(ViewInRoomButton, "defaultProps", {
  scaled: false,
  backgroundPicture: null
});
export {
  ViewInRoomButton
};
